export const getSearchItemData = (item: any) => ({
  title: item.__typename === 'Campaign' ? item.artist.name : item.name,
  subtitle: item.__typename === 'Campaign' ? item.name : item.campaign.name,
  facebookId: item.__typename === 'Campaign' ? item.artist.facebook_id : item.parent_id,
  spotifyId: item.__typename === 'Campaign' ? item.artist.spotify_id : ''
})
